import { render } from "./HoldingCountdown.vue?vue&type=template&id=5a1b385d&scoped=true"
import script from "./HoldingCountdown.vue?vue&type=script&lang=js"
export * from "./HoldingCountdown.vue?vue&type=script&lang=js"

import "./HoldingCountdown.vue?vue&type=style&index=0&id=5a1b385d&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/rb-redev/rb-redev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a1b385d"]])

export default __exports__